import axios from 'axios';
import router from '../../router';

const api = 'v2/changelog';

const store = {
    state: {
        status: '',
        data: [],
        relevant: [],
    },

    getters: {
        getStatus: (state) => state.status,
        getAll: (state) => state.data,
        getRelevant: (state) => state.relevant,
    },

    actions: {
        async fetch({ commit }) {
            commit('start_loading');
            await axios.get(`/api/${api}`).then((response) => {
                commit('end_loading');
                commit('set_data', response.data?.data);
            });
        },
        async fetchRelevant({ commit }) {
            commit('start_loading');
            await axios.get(`/api/${api}/relevant/pp`).then((response) => {
                commit('end_loading');
                commit('set_relevant', response.data?.data);
            });
        },
        async add({ commit, dispatch }, { data }) {
            return new Promise((resolve, reject) => {
                commit('start_loading');
                axios
                    .post(`/api/${api}`, data)
                    .then(async (res) => {
                        await dispatch('fetch');
                        resolve();
                    })
                    .catch((e) => {
                        reject();
                        console.error(e);
                    })
                    .finally(() => {
                        commit('end_loading');
                    });
            });
        },
        async update({ commit, dispatch }, { data, id }) {
            return new Promise((resolve, reject) => {
                commit('start_loading');
                axios
                    .put(`/api/${api}/${id}`, data)
                    .then(async (res) => {
                        resolve();
                    })
                    .catch((e) => {
                        reject();
                        console.error(e);
                    })
                    .finally(() => {
                        commit('end_loading');
                    });
            });
        },
        async remove({ commit, dispatch }, { id }) {
            return new Promise((resolve, reject) => {
                commit('start_loading');
                axios
                    .delete(`/api/${api}/${id}`)
                    .then(async (res) => {
                        await dispatch('fetch');
                        resolve();
                    })
                    .catch((e) => {
                        reject();
                        console.error(e);
                    })
                    .finally(() => {
                        commit('end_loading');
                    });
            });
        },
    },

    mutations: {
        set_data(state, data) {
            state.data = data || [];
        },
        set_relevant(state, data) {
            state.relevant = data || [];
        },
        start_loading(state) {
            state.status = 'loading';
        },
        end_loading(state) {
            state.status = 'success';
        },
    },
};

export default {
    ...store,
    namespaced: true,
};
